import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import DefaultTransaction from "./DefaultTransaction";
import { getComponent, getContextModules } from "../../../../lib/requireContextHelper";

const context = require.context("./", true, /\.\/Transaction[a-zA-Z]*\/index.ts/);
const modules = getContextModules(context);

export function getTransactionItem(transaction: Transaction) {
  return getComponent(modules, transaction.details, DefaultTransaction);
}
